var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42426 0.325736C6.65858 0.560051 6.65858 0.93995 6.42426 1.17426L1.59853 6L6.42426 10.8257C6.65858 11.0601 6.65858 11.4399 6.42426 11.6743C6.18995 11.9086 5.81005 11.9086 5.57574 11.6743L0.325736 6.42426C0.0914214 6.18995 0.0914214 5.81005 0.325736 5.57574L5.57574 0.325736C5.81005 0.0914214 6.18995 0.0914214 6.42426 0.325736Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.ca54acdaacec14ae727d7efd47103fef.svg";
export { ForwardRef as ReactComponent };